import React, { Fragment } from 'react';
import { bool, number, oneOf, shape, string } from 'prop-types';
import AmpHtml from 'components/Html';
import AmpImg from 'components/AmpImg';
import { imageUrl } from 'util/images';

function AmpGalleryItem({
  image,
  imageLayout,
  slidePos,
  post,
  imageCount,
  type,
  hasPrism
}) {
  return (
    <div
      className={`Gallery__slide Gallery__slide--image Gallery__slide--image-${slidePos}`}
    >
      {type !== 'caption' && (
        <Fragment>
          <div className="Gallery__slide-position">
            <span className="Gallery__slide-counter">{slidePos}</span>
            <span className="Gallery__slide-position-separator"> of </span>
            <span className="Gallery__slide-total">{imageCount}</span>
          </div>
          <div className="Gallery__slide-image">
            <AmpImg
              url={imageUrl(image.url)}
              alt={image.alt}
              isPinnable={image.isPinnable}
              post={{
                canonical: post.canonical
              }}
              layout={imageLayout}
              originalWidth={image.originalWidth}
              originalHeight={image.originalHeight}
              hashedPublicId={image.hashedPublicId}
              hasPrism={hasPrism}
              caption={image.credit}
            />
          </div>
        </Fragment>
      )}
      {type !== 'image' && image.caption && (
        <figcaption className="ImageCaption">
          <span className="ImageCaption__caption">
            <AmpHtml html={image.caption.replace(image.credit, '')} />
          </span>
        </figcaption>
      )}
    </div>
  );
}

AmpGalleryItem.propTypes = {
  slidePos: number.isRequired,
  image: shape(AmpImg.propTypes),
  imageLayout: string,
  post: shape({
    canonical: string
  }),
  imageCount: number.isRequired,
  type: oneOf(['image', 'caption', 'whole']),
  hasPrism: bool
};

AmpGalleryItem.defaultProps = {
  image: undefined,
  imageLayout: 'responsive',
  post: undefined,
  type: 'whole',
  hasPrism: false
};

export default AmpGalleryItem;
